export { default } from "./OvalTable";
